import { ComponentType } from 'react';
import { RouteComponentProps } from 'react-router';

import { Categories } from './data';
import { Category, UpsertAsset, AssetDetails, Changes } from './pages';
import { Collaboration } from './pages/collaboration/Collaboration';
import { IconType } from './components';
import { NewPaper } from './pages/papers/NewPaper';

/**
 * Interface defining the shape of an individual route.
 */
export interface AppRoute {
    /* The url path, i.e. in the url `http://localhost/about`, `/about` is the path. */
    path: string;

    /* The name of the route that's displayed in the navigation. */
    label?: string;

    /* The component that's rendered when that route is active. */
    component?: ComponentType<RouteComponentProps<any>>;

    /* gray out in menu */
    disabled?: boolean;

    /* icon to display */
    iconName?: string;

    /* is this icon sourced form antd or url */
    iconType?: IconType;

    exact?: boolean;
}

export interface AppRouteGroup {
    /* The name of the route that's displayed in the navigation. */
    label?: string;

    /* icon to display */
    iconName?: string;

    /* routes that are in this group */
    routes: AppRoute[];
}

export const RouteGroups: AppRouteGroup[] = [
    {
        // label: 'Categories',
        routes: Object.entries(Categories).map(([k, v]) => {
            return {
                path: `/category/${k}`,
                label: v.label,
                iconName: v.iconName,
                iconType: v.iconType,
            };
        }),
    },
    {
        routes: [
            {
                path: '/changes',
                label: 'Changes',
                iconName: 'changes',
                iconType: 'url',
                component: Changes,
                exact: true,
            },
        ],
    },
];

export const AllRoutes: AppRoute[] = [
    // note: order in this array matters for which
    // route will be selected.
    // Specifically: the '/category/papers/new' papers route needs to
    // come before '/category/:category/new' in order to override the generic path
    {
        path: '/category/papers/new',
        component: NewPaper,
        exact: true,
    },
    {
        path: '/category/:category/new',
        component: UpsertAsset,
        exact: true,
    },
    {
        path: '/category/:category/:id/edit',
        component: UpsertAsset,
        exact: true,
    },
    {
        path: '/category/:category/:id',
        component: AssetDetails,
        exact: true,
    },
    {
        path: '/category/:category',
        component: Category,
        exact: true,
    },

    ...RouteGroups.reduce((acc: AppRoute[], c: AppRouteGroup) => acc.concat(c.routes), []), // flatmap

    // pages that dont have a menu
    {
        path: '/collaborations',
        component: Collaboration,
        exact: true,
    },
];
